import React from "react";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import MDButton from "components/MDButton";
import PageShell, { SectionCard } from "components/patch/PageShell";

export default function PayrollConfig() {
  return (
    <PageShell title="Payroll Configurations" subtitle="Shortcuts to payroll period, exceptions, pension, NHF and irregular allowance configuration.">
      <SectionCard title="Configuration Shortcuts">
        <Grid container spacing={2}>
          {[
            ["Payroll Run / Period", "/payroll/run"],
            ["Payroll Exceptions / Exit Due Review", "/payroll/exit-due-review"],
            ["Pension Schedule", "/reports/statutory/pension"],
            ["NHF Reports", "/reports/statutory/nhf"],
            ["Tax Regimes", "/settings/tax-regimes"],
            ["Tax Claims", "/settings/tax-claims"],
            ["Tax Policies", "/settings/tax-policies"],
            ["Irregular Allowance Rules", "/setup/irregularallowances"],
          ].map(([label, path]) => (
            <Grid item xs={12} md={4} key={path}>
              <MDButton component={Link} to={path} variant="gradient" color="warning" fullWidth>{label}</MDButton>
            </Grid>
          ))}
        </Grid>
      </SectionCard>
    </PageShell>
  );
}
